/* eslint-disable */
import { useMemo } from "react";
import { useDictionary, useOLAPTransformer, OLAPTransformerResult, OLAPTransformerOptions, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import { SLIDE_NUMBER } from "../constants";

const UNITS_AXIS = "units.default";
const ROW_AXIS = "commodities.default";
const COLUMN_AXIS = "calendar.default";

export function useTableData(olapResult: OLAPResult | null): OLAPTransformerResult | null {
  const [, calendarDict] = useDictionary(dictionaryService, "slides-calendar-slide17");
  const [, unitsDict] = useDictionary(dictionaryService, "slides-units");
  const [itemsCommodities, commoditiesDict] = useDictionary(dictionaryService, "slides-commodities");
  const [itemsCommoditiesDisplay] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
    'slide': SLIDE_NUMBER,
    'business_unit': 1,
  });

  const options = useMemo<OLAPTransformerOptions | null>(() => {
    if ([olapResult, calendarDict, unitsDict, commoditiesDict, itemsCommodities, itemsCommoditiesDisplay].some(x => !Boolean(x))) {
      return null;
    }

    return {
      data: olapResult?.data,
      attrsNameProxy: new Map([
        [`${ROW_AXIS}.name`, (id: unknown, lcid: number) => {
          const itemDisplay = itemsCommoditiesDisplay?.find(x => Number(x.getValue('olap_commodity')) === Number(id));
          const item = itemsCommodities?.find(x => Number(x.id) === Number(id));
          return (itemDisplay || item)?.getValue('name') || { [lcid]: '' };
        }],
        [`${ROW_AXIS}.comment`, (id: unknown, lcid: number) => {
          const itemDisplay = itemsCommoditiesDisplay?.find(x => Number(x.getValue('olap_commodity')) === Number(id));
          return itemDisplay?.getValue('comment') || '';
        }]
      ]),
      attrsDictionaries: new Map([
        [COLUMN_AXIS, calendarDict],
        [ROW_AXIS, commoditiesDict],
        [UNITS_AXIS, unitsDict],
      ]) as ReadonlyMap<string, Dictionary>
    } as OLAPTransformerOptions
  }, [olapResult, calendarDict, unitsDict, commoditiesDict, itemsCommodities, itemsCommoditiesDisplay]);

  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${COLUMN_AXIS}.name`, `${COLUMN_AXIS}.id`],
      rows: [`${ROW_AXIS}.name`, `${ROW_AXIS}.id`, `${ROW_AXIS}.comment`],
      cellData: {
        inCell: ["value"].map(
          measure => `Measures.${measure}`
        ),
        attributes: [`${COLUMN_AXIS}.name`, `${ROW_AXIS}.name`, `${COLUMN_AXIS}.id`, `${ROW_AXIS}.id`],
      },
    }
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
